import { Dashboard, PersonGear } from 'phx-core';

import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';

import { SidebarService, ISidebarState } from '@services/sidebar.service';

@Component({
  selector: 'dashboard-admin-switcher',
  templateUrl: './dashboard-admin-switcher.component.html',
  styleUrls: ['./dashboard-admin-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardAdminSwitcherComponent implements OnInit {
  @HostBinding('class.collapse-sidebar') public isSideBarCollapsed: boolean;
  @HostBinding('class.expand-sidebar') public isSideBarMaximized: boolean;
  @HostBinding('class.light-theme') @Input() public isLightTheme: boolean;
  @Input() public switchingLink: string;

  public readonly personGearIcon: string = PersonGear;
  public readonly dashboardIcon: string = Dashboard;
  public switcherLinkRegex = /\/?admin/;

  constructor(
    private sidebarService: SidebarService,
  ) {
  }

  public ngOnInit() {
    this.sidebarService.stateListener.subscribe((state: ISidebarState) => {
      this.isSideBarCollapsed = state === 'collapsed';
    });
  }
}
